import { BrowserRouter } from "react-router-dom";
// routes
import Routes from "./routes";
// contexts
import { AppContextProvider } from "./contexts/AppContextProvider";
// providers
import NotistackProvider from "./providers/NotistackProvider";
import DatePickerLocatizationProvider from "./providers/DatePickerLocatizationProvider";
// components
import MotionLazyContainer from "./components/animate/MotionLazyContainer";
import { NavigationMenu } from "./components/layout";
// theme
import { AppProvider } from "@shopify/polaris";
import enTranslations from "@shopify/polaris/locales/en.json";

import ThemeProvider from "./theme";

const App = () => {
  return (
    <BrowserRouter>
      <MotionLazyContainer>
        <AppProvider i18n={enTranslations}>
          <ThemeProvider>
            <NotistackProvider>
              <AppContextProvider>
                <DatePickerLocatizationProvider>
                  <NavigationMenu />
                  <Routes />
                </DatePickerLocatizationProvider>
              </AppContextProvider>
            </NotistackProvider>
          </ThemeProvider>
        </AppProvider>
      </MotionLazyContainer>
    </BrowserRouter>
  );
};

export default App;
